import { useSelector } from "react-redux";
import style from "./favourite.module.scss";
import { selectMPSTopicFile } from "../../features/counter/counterSlice";
import classNames from "classnames";
import PropTypes from "prop-types";

const Favourite = ({ title, url, type, guideline, removeFavourite }) => {
  const mpstopicfile = useSelector(selectMPSTopicFile);
  const topicDetailsFromMps = mpstopicfile?.[guideline] || {};

  return (
    <div className={classNames("size-14", style.favouriteContainer)}>
      <a className={style.favouriteLink} href={url}>
        <div>
          <span
            className={classNames(
              "squareIcon",
              topicDetailsFromMps?.squareIconClass,
              style.squareIcon,
            )}></span>
        </div>
        <div className={style.favouriteText}>
          <div className="size-12">{topicDetailsFromMps?.text}</div>
          <div>{title}</div>
        </div>
      </a>
      <div className={style.removeFavouriteSection}>
        <button className={style.removeFavouriteButton} type="button" onClick={() => removeFavourite(title, url, type, guideline)} data-testid="crossButton">
          <i className="tg-icons-Cross size-24"></i>
        </button>
      </div>
    </div>
  );
};

Favourite.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  guideline: PropTypes.string.isRequired,
  removeFavourite: PropTypes.func.isRequired,
};

export default Favourite;
